import { render, staticRenderFns } from "./StockEdit.vue?vue&type=template&id=5d0c9578&scoped=true&"
import script from "./StockEdit.vue?vue&type=script&lang=js&"
export * from "./StockEdit.vue?vue&type=script&lang=js&"
import style0 from "./StockEdit.vue?vue&type=style&index=0&id=5d0c9578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c9578",
  null
  
)

export default component.exports